import { createBrowserRouter } from 'react-router-dom';
import Layout from '@/components/layout/Layout';
import AdminLayout from '@/components/layout/AdminLayout';
import ProtectedRoute from './ProtectedRoute';

import BrandPage from '@/pages/BrandPage';
import ProductListPage from '@/pages/ProductListPage';
import ProductDetailPage from '@/pages/ProductDetailPage';
import CartPage from '@/pages/CartPage';
import CheckoutPage from '@/pages/CheckoutPage';
import PaymentSuccessPage from '@/pages/PaymentSuccessPage';
import PaymentFailPage from '@/pages/PaymentFailPage';
import OrderListPage from '@/pages/OrderListPage';
import OrderDetailPage from '@/pages/OrderDetailPage';
import LoginPage from '@/pages/LoginPage';
import SignupPage from '@/pages/SignupPage';
import OAuthCallbackPage from '@/pages/OAuthCallbackPage';
import MyPage from '@/pages/MyPage';
import BoardListPage from '@/pages/BoardListPage';
import BoardDetailPage from '@/pages/BoardDetailPage';
import BoardWritePage from '@/pages/BoardWritePage';
import NotFoundPage from '@/pages/NotFoundPage';

import AdminDashboardPage from '@/pages/admin/AdminDashboardPage';
import AdminCategoryPage from '@/pages/admin/AdminCategoryPage';
import AdminProductFormPage from '@/pages/admin/AdminProductFormPage';
import AdminProductListPage from '@/pages/admin/AdminProductListPage';
import AdminOrderListPage from '@/pages/admin/AdminOrderListPage';
import AdminUserListPage from '@/pages/admin/AdminUserListPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <NotFoundPage />,
    children: [
      { index: true, element: <BrandPage /> },
      { path: 'products', element: <ProductListPage /> },
      { path: 'products/:productId', element: <ProductDetailPage /> },
      { path: 'cart', element: <CartPage /> },
      {
        path: 'checkout',
        element: (
          <ProtectedRoute>
            <CheckoutPage />
          </ProtectedRoute>
        ),
      },
      { path: 'order/payment/success', element: <PaymentSuccessPage /> },
      { path: 'order/payment/fail', element: <PaymentFailPage /> },
      {
        path: 'orders',
        element: (
          <ProtectedRoute>
            <OrderListPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'orders/:orderId',
        element: (
          <ProtectedRoute>
            <OrderDetailPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'mypage',
        element: (
          <ProtectedRoute>
            <MyPage />
          </ProtectedRoute>
        ),
      },
      { path: 'boards', element: <BoardListPage /> },
      { path: 'boards/:postId', element: <BoardDetailPage /> },
      {
        path: 'boards/write',
        element: (
          <ProtectedRoute>
            <BoardWritePage />
          </ProtectedRoute>
        ),
      },
      { path: 'login', element: <LoginPage /> },
      { path: 'signup', element: <SignupPage /> },
      { path: 'oauth/callback', element: <OAuthCallbackPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
  {
    path: '/admin',
    element: (
      <ProtectedRoute requireManager>
        <AdminLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <AdminDashboardPage /> },
      { path: 'products', element: <AdminProductListPage /> },
      { path: 'products/new', element: <AdminProductFormPage /> },
      { path: 'products/:productId/edit', element: <AdminProductFormPage /> },
      { path: 'categories', element: <AdminCategoryPage /> },
      { path: 'orders', element: <AdminOrderListPage /> },
      {
        path: 'users',
        element: (
          <ProtectedRoute requireAdmin>
            <AdminUserListPage />
          </ProtectedRoute>
        ),
      },
    ],
  },
]);
